/**
 * Tymes4 Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type MembershipRenewalBatchStatus = 1 | 2 | 3 | 4;

export const MembershipRenewalBatchStatus = {
    Created: 1 as MembershipRenewalBatchStatus,
    PartiallyAccepted: 2 as MembershipRenewalBatchStatus,
    Accepted: 3 as MembershipRenewalBatchStatus,
    NotAccepted: 4 as MembershipRenewalBatchStatus
};

